import { mapFormDataToFilters, mapFiltersToFormData } from '@/entities/Document';
import type { Filters } from '@/entities/Document';
import { DEFAULT_FILTERS_FORM_DATA } from '@/entities/Document';
import { useGenericFilterModal } from '@/shared/lib';
import type { BaseFilterData } from '@/shared/lib';

export function useDocumentFilterModal(
  emitFunc: (...args: any[]) => void,
  fetchUsersFunc?: () => Promise<void>,
  initialFilters?: Partial<Filters>
) {
  const genericFilter = useGenericFilterModal(
    emitFunc,
    DEFAULT_FILTERS_FORM_DATA as BaseFilterData,
    fetchUsersFunc,
    initialFilters as Partial<BaseFilterData>,
    mapFiltersToFormData as (filters: any) => BaseFilterData
  );

  const applyFilters = () => {
    genericFilter.applyFilters(mapFormDataToFilters);
  };

  return {
    ...genericFilter,
    applyFilters,
  };
}
